import { useEffect, useState } from 'react'
import { fetchData } from '../../../../reusable'
import { ChartsWidget9v3 } from '../../dashboard/DashboardChart3'
import { Tr } from '../../../../_metronic/i18n/Tr'

const ViewCategoryWiseEarningByYearMonth = () => {
  let t = Tr()

  const [chartData, setChartData] = useState<
    {
      name: string
      data: { x: string; y: number; commission: number; booking: number; avgCost: number }[]
    }[]
  >([])
  const [categories, setCategories] = useState<string[]>([])
  const [totalRevenue, setTotalRevenue] = useState('')
  const [data, setData] = useState<any>(null)
  const [length, setLength] = useState('')

  const getData = (data: any) => {
    setData(data)
  }
  const currentYear = new Date().getFullYear()

  const fetchRevenueData = async () => {
    var param: any = {}
    if (data && data.year && data.monthId) {
      param = {
        year: data.year,
        month: data.monthId,
      }
    } else if (data && data.year) {
      param = {
        year: data.year,
      }
    } else {
      param = {
        year: currentYear
      }
    }

    const res = await fetchData('admin/totalCategoryRevenueByYearsOrMonth', param)
    if (res.status == '200') {
      const data = res.data
      setLength(data.length)

      const totalRevenue = data.map((item: any) => parseFloat(item.totalamount))
      const totalCommission = data.map((item: any) => parseFloat(item.totalcommission))

      const totalBooking = data.map((item: any) => parseFloat(item.totalbookingcount))
      const avgCost = data.map((item: any) => parseFloat(item.avgtotalamount))

      const totalServiceFeeAmount = data.reduce((acc: any, item: any) => {
        return parseFloat(acc) + (item.totalamount ? parseFloat(item.totalamount) : 0)
      }, 0)
      setTotalRevenue(totalServiceFeeAmount)

      // Map categories first and store it in a variable
      const mappedCategories = data.map((item: any) =>
        item.categoryId == '1'
          ? t('Accommodation')
          : item.categoryId == '2'
            ? t('Restaurant')
            : item.categoryId == '4'
              ? t('Space Rental')
              : item.categoryId == '5'
                ? t('Tour Package')
                : item.categoryId == '7' ? t('Car Rental') :""
      );

      // Set categories state with the mapped categories
      setCategories(mappedCategories);

      // Correct the structure of the chart data using the mapped categories directly
      setChartData([
        {
          name: '',
          data: data.map((item: any, index: any) => ({
            x: mappedCategories[index],
            y: totalRevenue[index],
            commission: totalCommission[index],
            booking: totalBooking[index],
            avgCost: avgCost[index],
          })),
        },
      ]);
    }
  };
  useEffect(() => {
    fetchRevenueData()
    document.title = 'Insayr | View Category Wise Earning By Year & Month'
  }, [data])


  return (
    <ChartsWidget9v3
      className='card-xl-stretch mb-5 mb-xl-8 height440px'
      data={chartData}
      sendData2={getData}
      categories={categories}
      totalRevenue={totalRevenue}
      length={length}
    />
  )
}

export default ViewCategoryWiseEarningByYearMonth
